import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

import { skuBrandKeys } from "./query-keys";

interface UnmappedFilter {
  search: string;
  offset: number;
  limit: number;
}

async function fetchUnmapped(f: UnmappedFilter) {
  const { data, error } = await apiClient.GET("/v1/sku", {
    params: {
      query: {
        brand: "unmapped",
        limit: f.limit,
        offset: f.offset,
        ...(f.search ? { name_contains: f.search } : {}),
      },
    },
  });
  if (error) throw error;
  return data;
}

/** GET /v1/sku?brand=unmapped — SKUs with no ap_name (spec §3.4). */
export function useUnmappedSkus(f: UnmappedFilter) {
  return useQuery({
    queryKey: skuBrandKeys.unmapped(f),
    queryFn: () => fetchUnmapped(f),
    staleTime: 30_000,
  });
}

/** Every unmapped SKU code, for "Copy list" (≈450 rows; §3.5 step 5). */
export async function fetchAllUnmappedCodes(search: string): Promise<string[]> {
  const data = await fetchUnmapped({ search, offset: 0, limit: 5000 });
  return (data.items ?? []).map((s) => s.sino_sku ?? "").filter(Boolean);
}
